import { ChangeEvent, useEffect, useRef, useState } from "react";
import {
  MdOutlineRemoveRedEye,
  MdFileDownload,
  MdCloudUpload,
  MdOutlineCloudDownload,
  MdUpload,
  MdDelete,
  MdEditDocument,
  MdInfoOutline,
} from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../../redux/store";
import NavbarVTX from "../../../../../components/common/Navbar";
import Button from "../../../../../components/common/Button";
import SectionHeading from "../../../../../components/common/SectionHeading";
import { useNavigate, useParams } from "react-router-dom";
import { getAppAction } from "../redux/action/getAppAction";
import Header from "../../../../../components/common/Header";
import "../pages/css/modalStyle.css";
import {
  Col,
  Container,
  Dropdown,
  DropdownButton,
  Modal,
  Row,
  Spinner,
  Image,
  ToastContainer,
  Toast,
} from "react-bootstrap";
import { getAuthSignatoriesAction } from "../redux/action/getAuthSignatoriesAction";
import { sendESignAction } from "../redux/action/sendESignAction";
import { getAllKeyPersonAction } from "../redux/action/getAllKeyPersonAction";
import handleFileWithSizeLimit from "../../../../constants/fileSizeLimit";
import { getSessionId, getUserRole } from "../../../../../utils/tokenHandlers";
import { uploadAttachment } from "../apis/uploadAttachment";
import { updateSignedApplication } from "../apis/updateSignedApplication";
import axios from "axios";
import { deleteCustomerDocument } from "../apis/deleteCustomerDocuments";
import { updateMasterAgreement } from "../apis/updateMasterAgreement";
import { fieldValidationAction } from "../redux/action/fieldValidation";
import { ValidationErrorModal } from "../components/ValidationErrorModal";
import { sendESignKpAction } from "../redux/action/sendEsignKpAction";
import { deleteKpDocument } from "../apis/deleteKpDocument";
import { getKybInfoAction } from "../redux/action/getKybInfoAction";
import { updateKeyPersonUpload } from "../apis/updateKeyPersonUpload";
import TextArea from "../../../../../components/common/Textarea";
import { useForm } from "react-hook-form";
import { SendBackComments } from "../../../../verificationStage/redux/types/VerificationDetailsType";
import { sendBackToFormFilling } from "../apis/sendBackToFormFilling";
import UidEmailRoleMatch from "../../../../constants/uidEmailRoleMatch";

const DocumentSigning: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  let { appId } = useParams();
  let customerId = Number(appId);

  const getAppSelector = useSelector(
    (state: RootState) => state.opsPpIndApp.getApp
  );

  const isCounterParty = getAppSelector.data.is_counterparty;
  const isGuestUser = getAppSelector.data.is_guest_user;

  const [showModal, setShowModal] = useState(false);
  const handleModalOpen = () => setShowModal(true);
  const handleModalClose = () => setShowModal(false);

  const [showPromptModal, setShowPromptModal] = useState(false);
  const handlePromptModalOpen = () => setShowPromptModal(true);
  const handlePromptModalClose = () => setShowPromptModal(false);

  const [spinnerKp, setSpinnerKp] = useState(false);
  const [showPromptModalKp, setShowPromptModalKp] = useState(false);
  const handlePromptModalKpOpen = () => setShowPromptModalKp(true);
  const handlePromptModalKpClose = () => setShowPromptModalKp(false);

  const [spinner, setSpinner] = useState(false);

  const [kybStatus, setKybStatus] = useState("");

  const {
    register,
    formState: { errors },
  } = useForm<SendBackComments>({
    shouldUnregister: true,
  });

  const [signatories, setSignatories] = useState<
    { id: number; name: string; email: string; counter: number }[]
  >([]);

  const [keyPersons, setKeyPersons] = useState<
    {
      id: number;
      name: string;
      email: string;
      status: string;
      signed_digio_key_id: any;
      digio_counter: number;
    }[]
  >([]);

  const fileInputRef1 = useRef<HTMLInputElement | null>(null);
  const fileInputRef2 = useRef<HTMLInputElement | null>(null);
  const fileInputRefs = useRef<Record<string, HTMLInputElement | null>>({});

  const [image, setImage] = useState<string | Blob>("");
  const [docName, setDocName] = useState<string | null>(null);
  let stage = `move_stage_form_signing_to_verification`;
  const navigate = useNavigate();

  // Store selected signatories' IDs
  const [selectedSignatories, setSelectedSignatories] = useState<number[]>([]);
  const [digioId, setDigioId] = useState("");
  const [kybSignData, setKybSignData] = useState<any[]>([]);

  useEffect(() => {
    // setValue("business_registered_with", "MCA");
    dispatch(getAppAction(customerId)).then((resp) => {
      // console.log(resp.payload);
      setKybStatus(resp.payload?.result?.signed_application_form_status);
      const status = resp.payload?.result?.signed_application_form_status;
      if (
        status == "E-Signed" ||
        isCounterParty ||
        status == "Physically Signed"
      ) {
        setDisableKybSendEsign(true);
      }

      // setKpStatus(resp.payload?.result?.signed_key_form_status);
      setDigioId(resp.payload?.result?.digio_id);
      if (resp.payload?.result?.master_agreeement_attachment_ids[0]) {
        setMAStatus("Uploaded");
      }
    });
  }, [dispatch, customerId]);

  useEffect(() => {
    if (isCounterParty) {
      setDisableKybSendEsign(true);
    }
  }, [getAppSelector]);

  const [validationError, setValidationError] = useState("");
  const [showValidationModal, setShowValidationModal] = useState(false);

  const [showBtnSpinner, setShowBtnSpinner] = useState(false);
  const openValidationModal = (validationErr: string) => {
    setValidationError(validationErr);
    setShowValidationModal(true);
  };
  const UpdateStageAndNavigate = async () => {
    setShowBtnSpinner(true);

    dispatch(getAppAction(customerId)).then(async (resp) => {
      // console.log(
      //   resp.payload.result.signed_application_form_attachment_ids.length,
      //   "here"
      // );
      if (
        resp.payload.result.signed_application_form_attachment_ids.length === 0
      ) {
        alert("Please upload Signed Application to continue!");
        setShowBtnSpinner(false);
      } else {
        const sendBackComments = "";
        const sendBack = await sendBackToFormFilling(
          customerId,
          sendBackComments
        ).then(() => {
          dispatch(fieldValidationAction({ customerId, stage })).then(
            (response) => {
              // console.log("Api resp-->", response);
              if (response.payload.error) {
                setShowBtnSpinner(false);
                const validationErr = response.payload.error.data.message;
                // console.warn(validationErr);
                openValidationModal(validationErr);
              } else {
                setShowBtnSpinner(false);
                navigate(`/ApplicationSubmission/${customerId}`);
              }
            }
          );
        });
      }
    });
  };

  const [showCmntsBox, setShowCmntsBox] = useState(false);

  useEffect(() => {
    dispatch(getAllKeyPersonAction(customerId)).then((resp) => {
      const data = resp.payload?.result?.result || [];
      // Transform data to { id, name } format
      const formattedKeyPerons = data.map((item: any) => ({
        id: item.id,
        name: `${item.first_name} ${item.last_name}`,
        email: item.email,
        status: item.signed_key_form_status,
        signed_digio_key_id: item.signed_digio_key_id,
        digio_counter: item.digio_counter,
      }));
      setKeyPersons(formattedKeyPerons);
      // setKpStatus
      // console.log(formattedKeyPerons);
    });
  }, [dispatch, customerId]);

  useEffect(() => {
    setSignatories([]);
    dispatch(getAuthSignatoriesAction(customerId)).then((resp) => {
      const data = resp.payload?.result?.result || [];
      // Transform data to { id, name } format
      const formattedSignatories = data.map((item: any) => ({
        id: item.id,
        name: `${item.first_name} ${item.last_name}`,
        email: item.email,
        counter: item.digio_counter,
      }));
      setSignatories(formattedSignatories);
      // console.log(formattedSignatories);
    });
  }, [dispatch, customerId]);

  // Store signatories list
  // Handle selection change
  const handleSelectChange = (signatoryId: number) => {
    setSelectedSignatories(
      (prevSelected) =>
        prevSelected.includes(signatoryId)
          ? prevSelected.filter((id) => id !== signatoryId) // Remove if already selected
          : [...prevSelected, signatoryId] // Add if not selected
    );
  };

  const [sendBackComments, setSendBackComments] = useState("");
  const [sendBackSpinner, setSendBackSpinner] = useState(false);
  const handleSendBack = async () => {
    if (!sendBackComments) {
      alert("Please enter Send Back Comments");
      return;
    }
    setSendBackSpinner(true);
    const userRole = getUserRole();
    // console.log(userRole);
    const sendBack = await sendBackToFormFilling(customerId, sendBackComments);
    // console.log(sendBack.data);
    let stage = `move_stage_to_in_form_filling`;
    dispatch(fieldValidationAction({ customerId, stage })).then((response) => {
      // console.log("Api resp-->", response);
      if (response.payload.error) {
        setSendBackSpinner(false);
        alert(response.payload.error.data.message);
        // // console.warn(validationErr);
        // openValidationModal(validationErr);
      } else {
        const docId = getAppSelector.data.master_agreeement_attachment_ids[0];
        if (!isCounterParty && docId) {
          handleMADelete();
        }
        alert("Application Sent Back for Correction!");
        if (userRole == "maker") {
          navigate(`/ops/dashboard`);
        } else {
          navigate("/");
        }

        setSendBackSpinner(false);
      }
    });
  };

  const [kpUploadSpinner, setKpUploadSpinner] = useState<
    Record<string, boolean>
  >({});

  const [safUploadSpinner, setSafUploadSpinner] = useState(false);

  const handleAPI = async () => {
    const files2 = fileInputRef2.current?.files;
    if (!files2 || files2.length === 0) {
      alert("Please select a file before uploading.");
      return;
    }
    setSafUploadSpinner(true);
    if (docName && image) {
      const sessionId = getSessionId();
      const response = await uploadAttachment(docName, image, sessionId);
      if (response.data.message === "Success") {
        const docId = response.data.data.attachement;
        if (docId) {
          const signedAppUpload = await updateSignedApplication(
            customerId,
            docId
          );
          if (signedAppUpload.data.result == true) {
            dispatch(getAppAction(customerId)).then((resp) => {
              setKybStatus(
                resp.payload?.result?.signed_application_form_status
              );
              const status =
                resp.payload?.result?.signed_application_form_status;
              if (status == "E-Signed" || status == "Physically Signed") {
                setDisableKybSendEsign(true);
              }
            });
            setSafUploadSpinner(false);
            alert("Signed Form Uploaded");
          } else {
            setSafUploadSpinner(false);
            alert("Something went wrong, Please contact Admin");
          }
        }
        if (fileInputRef2.current) {
          fileInputRef2.current.value = "";
          // setButtonText("Upload");
        }
      }
    } else {
      setSafUploadSpinner(false);
      alert("Something went wrong!");
    }
  };

  const [maUploadSpinner, setMaUploadSpinner] = useState(false);
  const [mAStatus, setMAStatus] = useState("Not Uplaoded");

  const handleAPIMA = async () => {
    const files1 = fileInputRef1.current?.files;
    if (!files1 || files1.length === 0) {
      alert("Please select a file before uploading.");
      return;
    }
    if (docName && image) {
      setMaUploadSpinner(true);
      const sessionId = getSessionId();
      const response = await uploadAttachment(docName, image, sessionId);
      if (response.data.message === "Success") {
        const docId = response.data.data.attachement;
        if (docId) {
          const signedAppUpload = await updateMasterAgreement(
            customerId,
            docId
          );
          if (signedAppUpload.data.result == true) {
            dispatch(getAppAction(customerId));
            setMaUploadSpinner(false);
            setMAStatus("Uploaded");
            alert("Master Agreement Uplaoded");
          } else {
            alert("Something went wrong, Please contact Admin");
            setMaUploadSpinner(false);
          }
        }

        if (fileInputRef1.current) {
          fileInputRef1.current.value = "";
          setMaUploadSpinner(false);
        }
      } else if (response.type === "uploadAttachment/rejected") {
        alert("Something went wrong, Please contact Admin");
        setMaUploadSpinner(false);
      }
    }
  };

  const [downloadPdfSpinner, setDownloadPdfSpinner] = useState(false);

  const handleDownloadPdf = async () => {
    const sessionid = getSessionId();
    const appNumber = customerId;

    try {
      setDownloadPdfSpinner(true);

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}application/print/${customerId}`,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${sessionid}`,
          },
        }
      );

      const fileName = `${appNumber}_ApplicationForm.pdf`;
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setDownloadPdfSpinner(false);
    } catch (error) {
      setDownloadPdfSpinner(false);
      alert("Something went wrong!");
      // console.error("An error occurred", error);
    }
  };

  const handleDownloadPdfKP = async (kpId: number) => {
    const sessionid = getSessionId();
    try {
      setDownloadPdfSpinnerKP((prev) => ({ ...prev, [kpId]: true }));

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}keyperson/print/${kpId}`,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${sessionid}`,
          },
        }
      );

      const fileName = `${kpId}_ApplicationForm.pdf`;
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      setDownloadPdfSpinnerKP((prev) => ({ ...prev, [kpId]: false }));
    } catch (error) {
      setDownloadPdfSpinnerKP((prev) => ({ ...prev, [kpId]: false }));
      alert("Something went wrong!");
      // console.error("An error occurred", error);
    }
  };

  const handleAPIKP = async (id: number) => {
    const fileInput = fileInputRefs.current[id]; // Get the first file

    if (!fileInput || !fileInput.files?.[0]) {
      alert("Please select a file before uploading.");
      return;
    }
    setKpUploadSpinner((prev) => ({ ...prev, [id]: true }));
    if (docName && image) {
      const sessionId = getSessionId();
      const response = await uploadAttachment(docName, image, sessionId);
      if (response.data.message === "Success") {
        const docId = response.data.data.attachement;
        if (docId) {
          const keyPersonUpload = await updateKeyPersonUpload(id, docId);
          // console.log(keyPersonUpload);
          // setKpUploadSpinner((prev) => ({ ...prev, [id]: false }));
          if (keyPersonUpload.data.result == true) {
            dispatch(getAllKeyPersonAction(customerId)).then((resp) => {
              const data = resp.payload?.result?.result || [];
              // Transform data to { id, name } format
              const formattedKeyPerons = data.map((item: any) => ({
                id: item.id,
                name: `${item.first_name} ${item.last_name}`,
                email: item.email,
                status: item.signed_key_form_status,
                signed_digio_key_id: item.signed_digio_key_id,
                digio_counter: item.digio_counter,
              }));
              setKeyPersons(formattedKeyPerons);
              setKpUploadSpinner((prev) => ({ ...prev, [id]: false }));
              alert("Key Person Form Uploaded");
            });
          } else {
            setKpUploadSpinner((prev) => ({ ...prev, [id]: false }));
            alert("Something went wrong, Please contact Admin");
          }
        }
        if (fileInput) {
          fileInput.value = "";
        }
      } else {
        setKpUploadSpinner((prev) => ({ ...prev, [id]: false }));
        alert("Something went wrong!");
      }
    }

    // Proceed with uploading the file
    // console.log("Uploading file:", file.name);
  };

  const [imageData, setImageData] = useState("");
  const [fileType, setFileType] = useState("");
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);
  const [showModalSpinner, setShowModalSpinner] = useState(false);
  const sessionId = getSessionId();

  const handleDocumentViewSA = async () => {
    setImageData("");
    dispatch(getAppAction(customerId));

    const docId = getAppSelector.data.signed_application_form_attachment_ids[0];
    const apiUrl = `${process.env.REACT_APP_BASE_URL}web/read/content/${docId}`;

    try {
      if (!docId) {
        alert("Signed Application is not yet Uploaded!");
        return;
      }

      handleShow();
      setShowModalSpinner(true);

      const response = await axios.post(
        apiUrl,
        { params: { ...UidEmailRoleMatch() } },
        {
          headers: {
            Authorization: `Bearer ${sessionId}`,
          },
        }
      );

      const fileString: string = response.data.result;

      if (fileString.startsWith("%PDF")) {
        // Convert string → binary array (safe for older TS targets)
        const byteArray = new Uint8Array(fileString.length);
        for (let i = 0; i < fileString.length; i++) {
          byteArray[i] = fileString.charCodeAt(i);
        }

        const blob = new Blob([byteArray], { type: "application/pdf" });
        const blobUrl = URL.createObjectURL(blob);
        setImageData(blobUrl);
        setFileType("pdf");
      } else {
        const base64Data = btoa(fileString);
        setImageData(`data:image/png;base64,${base64Data}`);
        setFileType("img");
      }
    } catch (error) {
      console.error("Error fetching Signed Application:", error);
    } finally {
      setShowModalSpinner(false);
    }
  };

  const [deleteAppForm, setDeleteAppForm] = useState(false);

  const handleSAFDelete = async () => {
    const docId = getAppSelector.data.signed_application_form_attachment_ids[0];
    if (docId) {
      setDeleteAppForm(true);
      const updateCustomerData = {
        signed_application_form_attachment_ids: [],
        signed_application_form_status: "Awaiting Signed Copy",
      };
      await deleteCustomerDocument(customerId, updateCustomerData).then(
        (resp) => {
          // console.log(resp);
          dispatch(getAppAction(customerId)).then((resp) => {
            setKybStatus(resp.payload?.result?.signed_application_form_status);
            // const status = resp.payload?.result?.signed_application_form_status;
            setDisableKybSendEsign(false);
            alert("Signed Application Form Deleted!");
            setDeleteAppForm(false);
          });
        }
      );
    } else {
      alert("Document not uploaded");
      setDeleteAppForm(false);
    }
  };

  const handleMADelete = async () => {
    const docId = getAppSelector.data.master_agreeement_attachment_ids[0];
    // console.log(docId);
    if (docId) {
      const updateCustomerData = {
        master_agreeement_attachment_ids: [],
      };
      await deleteCustomerDocument(customerId, updateCustomerData).then(
        (resp) => {
          // console.log(resp);
          dispatch(getAppAction(customerId)).then((resp) => {
            alert("Master Agreement Deleted!");
            setMAStatus("Not Uploaded");
          });
        }
      );
    } else {
      alert("Master Agreement is not yet Uploaded!");
    }
  };

  // Master Agreement
  const handleDocumentViewMA = async () => {
    setImageData("");

    const docId = getAppSelector.data?.master_agreeement_attachment_ids[0];
    if (!docId) {
      alert("Master Agreement is not yet Uploaded!");
      return;
    }

    const apiUrl = `${process.env.REACT_APP_BASE_URL}web/read/content/${docId}`;

    try {
      handleShow();
      setShowModalSpinner(true);

      const response = await axios.post(
        apiUrl,
        { params: { ...UidEmailRoleMatch() } },
        {
          headers: {
            Authorization: `Bearer ${sessionId}`,
          },
        }
      );

      const fileString: string = response.data.result;

      if (fileString.startsWith("%PDF")) {
        // Convert string → binary array (safe for older TS targets)
        const byteArray = new Uint8Array(fileString.length);
        for (let i = 0; i < fileString.length; i++) {
          byteArray[i] = fileString.charCodeAt(i);
        }

        const blob = new Blob([byteArray], { type: "application/pdf" });
        const blobUrl = URL.createObjectURL(blob);
        setImageData(blobUrl);
        setFileType("pdf");
      } else {
        const base64Data = btoa(fileString);
        setImageData(`data:image/png;base64,${base64Data}`);
        setFileType("img");
      }
    } catch (error) {
      console.error("Error fetching Master Agreement:", error);
    } finally {
      setShowModalSpinner(false);
    }
  };

  // KYC / KP document
  const handleKpView = async (id: any) => {
    setImageData("");

    if (!id) {
      alert("Signed Form is not yet Uploaded!");
      return;
    }

    const apiUrl = `${process.env.REACT_APP_BASE_URL}web/read/content/${id}`;

    try {
      handleShow();
      setShowModalSpinner(true);

      const response = await axios.post(
        apiUrl,
        { params: { ...UidEmailRoleMatch() } },
        {
          headers: {
            Authorization: `Bearer ${sessionId}`,
          },
        }
      );

      const fileString: string = response.data.result;

      if (fileString.startsWith("%PDF")) {
        // Convert string → binary array (safe for older TS targets)
        const byteArray = new Uint8Array(fileString.length);
        for (let i = 0; i < fileString.length; i++) {
          byteArray[i] = fileString.charCodeAt(i);
        }

        const blob = new Blob([byteArray], { type: "application/pdf" });
        const blobUrl = URL.createObjectURL(blob);
        setImageData(blobUrl);
        setFileType("pdf");
      } else {
        const base64Data = btoa(fileString);
        setImageData(`data:image/png;base64,${base64Data}`);
        setFileType("img");
      }
    } catch (error) {
      console.error("Error fetching file:", error);
    } finally {
      setShowModalSpinner(false);
    }
  };

  const handleKpDelete = async (id: any, kpId: number) => {
    // console.log(id);
    if (id) {
      const data = {
        signed_digio_key_id: false,
        signed_key_form_status: "Awaiting Signed Copy",
      };
      await deleteKpDocument(kpId, data).then((resp) => {
        // console.log(resp);
        dispatch(getAllKeyPersonAction(customerId)).then((resp) => {
          const data = resp.payload?.result?.result || [];
          // Transform data to { id, name } format
          const formattedKeyPerons = data.map((item: any) => ({
            id: item.id,
            name: `${item.first_name} ${item.last_name}`,
            email: item.email,
            status: item.signed_key_form_status,
            signed_digio_key_id: item.signed_digio_key_id,
            digio_counter: item.digio_counter,
          }));
          setKeyPersons(formattedKeyPerons);
          alert("Signed Form Deleted");
          // setKpStatus()
        });
      });
    } else {
      alert("Document not uploaded");
    }
  };

  const handleImage = (e: ChangeEvent<HTMLInputElement>) => {
    const selectedFiles = e.target.files;

    if (selectedFiles && selectedFiles.length > 0) {
      const selectedFile = selectedFiles[0];

      // Check if the file type is allowed
      const allowedTypes = ["pdf"];
      const fileType = selectedFile.name.split(".").pop()?.toLowerCase();

      if (!fileType || !allowedTypes.includes(fileType)) {
        // Display an alert or take appropriate action
        alert("Unsupported file type. Please select a pdf");
        return;
      } else {
        setImage(selectedFile);
        // localStorage.setItem("fileName", selectedFile.name);
        setDocName(selectedFile.name);
      }

      // setUploadDisabled(false);
      // setButtonText("Upload");
    }
  };

  const handleConfirmSelection = () => {
    if (selectedSignatories.length > 0) {
      // console.log("Selected Signatories:", selectedSignatories);
      handlePromptModalOpen();
      handleModalClose();
    } else {
      alert("Please select Signatory Name");
    }

    // handleModalClose();
  };

  const [disableKybSendEsign, setDisableKybSendEsign] = useState(false);

  const handleSendESign = () => {
    if (kybStatus == "E-Signed") {
      alert("Document is already signed");
    } else {
      setSelectedSignatories([]);
      dispatch(getAuthSignatoriesAction(customerId)).then((resp) => {
        const data = resp.payload?.result?.result || [];
        // Transform data to { id, name } format
        const formattedSignatories = data.map((item: any) => ({
          id: item.id,
          name: `${item.first_name} ${item.last_name}`,
          email: item.email,
          counter: item.digio_counter,
        }));
        setSignatories(formattedSignatories);
        // console.log(formattedSignatories);
        handleModalOpen();
      });
    }
  };

  const [kpId, setKpId] = useState<number>();
  const [kpEmail, setKpEmail] = useState("");
  const [kpCounter, setKpCounter] = useState<number>();

  const handleeSignKeyPerson = (
    id: number,
    status: string,
    email: string,
    counter: number
  ) => {
    setKpEmail("");
    if (!counter) {
      setKpCounter(0);
    }
    if (status == "E-Signed") {
      alert("Document already signed/ sent for eSign");
    } else {
      setKpId(0);
      if (id) {
        setKpEmail(email);
        setKpCounter(counter);
        if (counter < 3) {
          handlePromptModalKpOpen();
          setKpId(id);
        } else {
          alert("E-Signing limit exceeded!");
        }
      } else {
        setKpEmail("");
        setKpCounter(0);
        alert("Something went wrong");
        setSpinnerKp(false);
      }
    }
  };

  const handleSendConfirm = () => {
    setSpinner(true);
    dispatch(
      sendESignAction({ appId: customerId, signatories: selectedSignatories })
    ).then((resp) => {
      // console.log(resp.payload);
      if (resp.payload?.result?.code == 200) {
        // handleModalOpen();
        alert("Request Sent! Please check email");
        dispatch(getAppAction(customerId)).then((resp) => {
          setKybStatus(resp.payload?.result?.signed_application_form_status);
          const status = resp.payload?.result?.signed_application_form_status;
          if (status == "E-Signed") {
            setDisableKybSendEsign(true);
          }
        });
        setSpinner(false);
        handlePromptModalClose();
      } else {
        if (resp.payload?.result?.code == 401) {
          alert(resp.payload?.result?.message);
        } else {
          alert("Something went wrong!");
        }
        setSpinner(false);
        handlePromptModalClose();
      }
    });
  };

  const [kpStatus, setKpStatus] = useState("");

  const handleSendConfirmKp = () => {
    // console.log(kpId);
    setSpinnerKp(true);
    dispatch(sendESignKpAction(kpId)).then((resp) => {
      // console.log(resp.payload);
      if (resp.payload?.result?.message == "Success!") {
        alert("Request Sent! Please check email");
        dispatch(getAllKeyPersonAction(customerId)).then((resp) => {
          const data = resp.payload?.result?.result || [];
          // Transform data to { id, name } format
          const formattedKeyPerons = data.map((item: any) => ({
            id: item.id,
            name: `${item.first_name} ${item.last_name}`,
            email: item.email,
            status: item.signed_key_form_status,
            signed_digio_key_id: item.signed_digio_key_id,
            digio_counter: item.digio_counter,
          }));
          setKeyPersons(formattedKeyPerons);
        });
        setSpinnerKp(false);
        handlePromptModalKpClose();
      } else if (resp.payload?.result?.code == 401) {
        // console.log(resp.payload?.result?.code, "here");
        alert(resp.payload?.result?.messge);
        setSpinnerKp(false);
        handlePromptModalKpClose();
      } else {
        alert("Something went wrong");
        setSpinnerKp(false);
        handlePromptModalKpClose();
      }
    });
  };
  const [showToast, setShowToast] = useState(false);
  const [infoSpinner, setInfoSpinner] = useState(false);
  const [downloadPdfSpinnerKP, setDownloadPdfSpinnerKP] = useState<
    Record<string, boolean>
  >({});

  const handleKYBInfo = () => {
    setInfoSpinner(true);
    dispatch(getKybInfoAction(digioId)).then((resp) => {
      if (resp.payload?.result?.data) {
        setKybSignData(resp.payload?.result?.data);
        // console.log(resp.payload?.result?.data);
        setShowToast(true);
        setInfoSpinner(false);
      } else if (resp.payload?.result?.code == "ENTITY_NOT_FOUND") {
        alert(resp.payload?.result?.message);
        setInfoSpinner(false);
      }
    });
  };

  const signedNames = kybSignData
    .filter((item) => item?.status === "signed")
    .map((item) => item?.name);

  // Construct the toast message
  const toastMessage =
    signedNames.length > 0
      ? `Signed by ${signedNames.join(", ")}`
      : "No signed documents found.";

  return (
    <>
      <NavbarVTX />

      <Header />
      <Container>
        {isGuestUser ? (
          <SectionHeading
            text={"Sign Application Form, KYB, and Keyperson KYC Documents"}
          />
        ) : (
          <SectionHeading
            text={
              "Sign Master Agreement, Application Form, KYB, and Keyperson KYC Documents"
            }
          />
        )}

        {/* <hr style={{ margin: "10px 0" }} /> */}
        <div className="p-6 rounded-2xl w-full">
          <table className="w-full table-fixed border-collapse m-4">
            <thead>
              <tr className="bg-gray-100" style={{ color: "#214382" }}>
                <th className="p-3 text-left">Document Name</th>
                <th className="p-3 text-left">Download</th>
                <th className="p-3 text-center">Send for eSign</th>
                <th className="text-center">Upload Signed Copy</th>
                <th className="text-center">Action</th>
                <th className="text-center">Status</th>
              </tr>
            </thead>
            <tbody>
              {!isCounterParty && !isGuestUser && (
                <tr className="border-t" style={{ color: "#214382" }}>
                  <td className="p-3">Master Agreement</td>
                  <td></td>

                  <td className="text-center"></td>
                  <td className="p-3 text-center">
                    <div className="d-flex align-items-center justify-content-center gap-2">
                      {/* File Input */}
                      <div
                        className="d-flex flex-column text-start"
                        style={{ maxWidth: "200px" }}
                      >
                        <input
                          type="file"
                          className="form-control"
                          ref={fileInputRef1}
                          accept=".pdf"
                          onChange={(e: ChangeEvent<HTMLInputElement>) =>
                            handleFileWithSizeLimit(e, undefined, handleImage)
                          }
                          style={{ width: "200px" }} // Adjust width as needed
                        />

                        {/* Display File Name if Selected */}
                        {fileInputRef1.current?.files?.[0] && (
                          <div
                            className="small text-break mt-1"
                            style={{
                              wordWrap: "break-word",
                              whiteSpace: "pre-wrap",
                            }}
                          >
                            {/* {fileInputRef1.current.files[0].name} */}
                          </div>
                        )}
                      </div>

                      {/* Upload Icon */}
                      <MdUpload
                        title="Upload Master Agreement"
                        onClick={handleAPIMA}
                        style={{
                          width: "40px",
                          height: "30px",
                          cursor: "pointer",
                          color: "#214382",
                        }}
                      />
                    </div>
                  </td>
                  <td className="text-center">
                    {/* <Button label={"Send"}></Button> */}
                    <MdOutlineRemoveRedEye
                      title="View Master Agreement"
                      // onClick={handleDownloadPdf}
                      style={{
                        width: "30px",
                        height: "20px",
                        cursor:
                          mAStatus !== "Uploaded" ? "not-allowed" : "pointer",

                        color: mAStatus !== "Uploaded" ? "#A0A0A0" : "#214382",
                        pointerEvents:
                          mAStatus !== "Uploaded" ? "none" : "auto",
                      }}
                      onClick={() => {
                        if (mAStatus == "Uploaded") {
                          handleDocumentViewMA();
                        }
                      }}
                    ></MdOutlineRemoveRedEye>
                    <MdDelete
                      title="Delete Master Agreement"
                      // onClick={handleDownloadPdf}
                      style={{
                        width: "30px",
                        height: "20px",
                        cursor:
                          mAStatus !== "Uploaded" ? "not-allowed" : "pointer",

                        color: mAStatus !== "Uploaded" ? "#A0A0A0" : "red",
                        pointerEvents:
                          mAStatus !== "Uploaded" ? "none" : "auto",
                      }}
                      onClick={() => {
                        if (mAStatus == "Uploaded") {
                          handleMADelete();
                        }
                      }}
                    ></MdDelete>
                  </td>
                  <td className="text-center" style={{ color: "#214382" }}>
                    <label>{mAStatus}</label>
                  </td>
                </tr>
              )}

              {/* <hr style={{ margin: "10px 0" }} /> */}
              <tr className="border-t" style={{ color: "#214382" }}>
                <td className="p-3">Application Form & KYB</td>
                <td className="text-center">
                  {downloadPdfSpinner ? (
                    <Spinner animation="border" variant="primary" />
                  ) : (
                    <MdFileDownload
                      title="Download Application Form"
                      style={{
                        width: "40px",
                        height: "30px",
                        cursor: "pointer",
                        color: "#214382",
                      }}
                      onClick={handleDownloadPdf}
                    />
                  )}
                </td>

                <td className="text-center">
                  {" "}
                  <MdEditDocument
                    title={"Send for eSign"}
                    onClick={() => {
                      if (!disableKybSendEsign) {
                        handleSendESign();
                      }
                    }}
                    style={{
                      width: "40px",
                      height: "30px",
                      cursor: disableKybSendEsign ? "not-allowed" : "pointer",
                      color: disableKybSendEsign ? "#A0A0A0" : "#214382",
                      pointerEvents: disableKybSendEsign ? "none" : "auto",
                    }}
                  />
                </td>
                <td className="p-3 text-center">
                  <div className="d-flex align-items-center justify-content-center gap-2">
                    {/* File Input */}
                    <div
                      className="d-flex flex-column text-start"
                      style={{ maxWidth: "200px" }}
                    >
                      <input
                        type="file"
                        className="form-control"
                        ref={fileInputRef2}
                        accept=".pdf"
                        onChange={(e: ChangeEvent<HTMLInputElement>) =>
                          handleFileWithSizeLimit(e, undefined, handleImage)
                        }
                        style={{ width: "200px" }} // Adjust width as needed
                      />

                      {/* Display File Name if Selected */}
                      {fileInputRef2.current?.files?.[0] && (
                        <div
                          className="small text-break mt-1"
                          style={{
                            wordWrap: "break-word",
                            whiteSpace: "pre-wrap",
                          }}
                        >
                          {/* {fileInputRef2.current.files[0].name} */}
                        </div>
                      )}
                    </div>

                    {/* Upload Icon or Spinner */}
                    {safUploadSpinner ? (
                      <Spinner animation="border" variant="primary" />
                    ) : (
                      <MdUpload
                        style={{
                          width: "40px",
                          height: "30px",
                          cursor:
                            kybStatus == "E-Signed" ? "not-allowed" : "pointer",

                          color:
                            kybStatus == "E-Signed" ? "#A0A0A0" : "#214382",
                          pointerEvents:
                            kybStatus == "E-Signed" ? "none" : "auto",
                        }}
                        title="Upload Hard Copy Application Form"
                        onClick={() => {
                          if (kybStatus !== "E-Signed") {
                            handleAPI();
                          }
                        }}
                      />
                    )}
                  </div>
                </td>
                <td className="p-3 text-center">
                  <div className="d-flex align-items-center justify-content-center">
                    {/* Download Icon or Spinner */}
                    {/* View Icon or Spinner */}
                    {showModalSpinner ? (
                      <Spinner animation="border" variant="primary" />
                    ) : (
                      <MdOutlineRemoveRedEye
                        title="View Application Form"
                        style={{
                          width: "30px",
                          height: "20px",
                          cursor:
                            kybStatus == "Awaiting Signed Copy" ||
                            kybStatus == "Sent for E-Sign"
                              ? "not-allowed"
                              : "pointer",

                          color:
                            kybStatus == "Awaiting Signed Copy" ||
                            kybStatus == "Sent for E-Sign"
                              ? "#A0A0A0"
                              : "#214382",
                          pointerEvents:
                            kybStatus == "Awaiting Signed Copy" ||
                            kybStatus == "Sent for E-Sign"
                              ? "none"
                              : "auto",
                        }}
                        onClick={() => {
                          if (
                            kybStatus !== "Awaiting Signed Copy" &&
                            kybStatus !== "Sent for E-Sign"
                          ) {
                            handleDocumentViewSA();
                          }
                        }}
                      />
                    )}
                    {deleteAppForm ? (
                      <Spinner animation="border" variant="primary" size="sm" />
                    ) : (
                      <MdDelete
                        title="Delete Application Form"
                        style={{
                          width: "30px",
                          height: "20px",
                          cursor:
                            kybStatus == "Awaiting Signed Copy" ||
                            kybStatus == "Sent for E-Sign"
                              ? "not-allowed"
                              : "pointer",

                          color:
                            kybStatus == "Awaiting Signed Copy" ||
                            kybStatus == "Sent for E-Sign"
                              ? "#A0A0A0"
                              : "red",
                          pointerEvents:
                            kybStatus == "Awaiting Signed Copy" ||
                            kybStatus == "Sent for E-Sign"
                              ? "none"
                              : "auto",
                        }}
                        onClick={() => {
                          if (
                            kybStatus !== "Awaiting Signed Copy" &&
                            kybStatus !== "Sent for E-Sign"
                          ) {
                            handleSAFDelete();
                          }
                        }}
                      />
                    )}
                  </div>
                </td>

                <td className="text-center" style={{ color: "#214382" }}>
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      // gap: "1px",
                      cursor: "pointer",
                      justifyContent: "center",
                    }}
                  >
                    <label>{kybStatus}</label>
                    {infoSpinner ? (
                      <Spinner
                        animation="border"
                        variant="primary"
                        size="sm"
                      ></Spinner>
                    ) : (
                      kybStatus !== "Physically Signed" &&
                      kybStatus !== "Awaiting Signed Copy" &&
                      kybStatus !== "Sent for E-Sign" && (
                        <MdInfoOutline title="Info" onClick={handleKYBInfo} />
                      )
                    )}
                  </span>
                </td>
              </tr>
              <ToastContainer position="middle-center" className="p-3">
                <Toast
                  onClose={() => setShowToast(false)}
                  show={showToast}
                  delay={5000}
                  autohide
                >
                  <Toast.Header>
                    <strong className="me-auto" style={{ color: "#214382" }}>
                      KYB Signing Information
                    </strong>
                  </Toast.Header>
                  <Toast.Body style={{ color: "#214382" }}>
                    {toastMessage}
                  </Toast.Body>
                </Toast>
              </ToastContainer>

              {/* <hr style={{ margin: "10px 0" }} /> */}

              {!isCounterParty &&
                keyPersons.map((keyPerson) => (
                  <tr key={keyPerson.id} style={{ color: "#214382" }}>
                    <td className="p-3">{keyPerson.name}: KYC Doc</td>
                    {/* <td>{keyPerson.email}</td> */}
                    <td className="text-center">
                      {" "}
                      {downloadPdfSpinnerKP[keyPerson.id] ? (
                        <Spinner animation="border" variant="primary" />
                      ) : (
                        <MdFileDownload
                          title="Download Key Person Form"
                          style={{
                            width: "40px",
                            height: "30px",
                            cursor: "pointer",
                            color: "#214382",
                          }}
                          onClick={() => {
                            handleDownloadPdfKP(keyPerson.id);
                          }}
                        />
                      )}
                    </td>
                    <td className="text-center">
                      <MdEditDocument
                        title="Send for eSign"
                        onClick={() => {
                          if (keyPerson.status !== "E-Signed") {
                            handleeSignKeyPerson(
                              keyPerson.id,
                              keyPerson.status,
                              keyPerson.email,
                              keyPerson.digio_counter
                            );
                          }
                        }}
                        style={{
                          width: "40px",
                          height: "30px",
                          cursor:
                            keyPerson.status == "E-Signed" ||
                            keyPerson.status == "Physically Signed"
                              ? "not-allowed"
                              : "pointer",
                          color:
                            keyPerson.status == "E-Signed" ||
                            keyPerson.status == "Physically Signed"
                              ? "#A0A0A0"
                              : "#214382",
                          pointerEvents:
                            keyPerson.status == "E-Signed" ||
                            keyPerson.status == "Physically Signed"
                              ? "none"
                              : "auto",
                        }}
                      />
                    </td>
                    <td className="p-3 text-center">
                      <div className="d-flex align-items-center justify-content-center gap-2">
                        {/* File Input */}
                        <div
                          className="d-flex flex-column text-start"
                          style={{ maxWidth: "200px" }}
                        >
                          <input
                            type="file"
                            className="form-control"
                            ref={(el) =>
                              (fileInputRefs.current[keyPerson.id] = el)
                            }
                            accept=".pdf"
                            onChange={(e: ChangeEvent<HTMLInputElement>) =>
                              handleFileWithSizeLimit(e, undefined, handleImage)
                            }
                            style={{ width: "200px" }}
                          />

                          {/* Display File Name if Selected */}
                          {fileInputRefs.current[keyPerson.id]?.files?.[0] && (
                            <div
                              className="small text-break mt-1"
                              style={{
                                wordWrap: "break-word",
                                whiteSpace: "pre-wrap",
                              }}
                            >
                              {
                                fileInputRefs.current[keyPerson.id]?.files?.[0]
                                  ?.name
                              }{" "}
                              {/* Add optional chaining here */}
                            </div>
                          )}
                        </div>

                        {/* Upload Icon or Spinner */}
                        {kpUploadSpinner[keyPerson.id] ? (
                          <Spinner animation="border" variant="primary" />
                        ) : (
                          <MdUpload
                            style={{
                              width: "40px",
                              height: "30px",
                              cursor:
                                keyPerson.status == "E-Signed"
                                  ? "not-allowed"
                                  : "pointer",

                              color:
                                keyPerson.status == "E-Signed"
                                  ? "#A0A0A0"
                                  : "#214382",
                              pointerEvents:
                                keyPerson.status == "E-Signed"
                                  ? "none"
                                  : "auto",
                            }}
                            title="Upload Hard Copy Key Person Form"
                            onClick={() => {
                              if (keyPerson.status !== "E-Signed") {
                                handleAPIKP(keyPerson.id);
                              }
                            }}
                          />
                        )}
                      </div>
                    </td>

                    <td className="p-4 text-center">
                      <div className="d-flex align-items-center justify-content-center">
                        <MdOutlineRemoveRedEye
                          title="View Key Person Form"
                          // onClick={handleDownloadPdf}
                          style={{
                            width: "30px",
                            height: "20px",
                            cursor:
                              keyPerson.status !== "E-Signed" &&
                              keyPerson.status !== "Physically Signed"
                                ? "not-allowed"
                                : "pointer",

                            color:
                              keyPerson.status !== "E-Signed" &&
                              keyPerson.status !== "Physically Signed"
                                ? "#A0A0A0"
                                : "#214382",
                            pointerEvents:
                              keyPerson.status !== "E-Signed" &&
                              keyPerson.status !== "Physically Signed"
                                ? "none"
                                : "auto",
                          }}
                          onClick={() => {
                            if (
                              keyPerson.status == "E-Signed" ||
                              keyPerson.status == "Physically Signed"
                            ) {
                              handleKpView(keyPerson.signed_digio_key_id);
                            }
                          }}
                        ></MdOutlineRemoveRedEye>
                        <MdDelete
                          title="Delete Key Person Form"
                          // onClick={handleDownloadPdf}
                          style={{
                            width: "30px",
                            height: "20px",
                            cursor:
                              keyPerson.status !== "E-Signed" &&
                              keyPerson.status !== "Physically Signed"
                                ? "not-allowed"
                                : "pointer",

                            color:
                              keyPerson.status !== "E-Signed" &&
                              keyPerson.status !== "Physically Signed"
                                ? "#A0A0A0"
                                : "red",
                            pointerEvents:
                              keyPerson.status !== "E-Signed" &&
                              keyPerson.status !== "Physically Signed"
                                ? "none"
                                : "auto",
                          }}
                          onClick={() => {
                            if (
                              keyPerson.status == "E-Signed" ||
                              keyPerson.status == "Physically Signed"
                            ) {
                              handleKpDelete(
                                keyPerson.signed_digio_key_id,
                                keyPerson.id
                              );
                            }
                          }}
                        ></MdDelete>
                      </div>
                    </td>
                    <td className="text-center">{keyPerson.status}</td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
        {showCmntsBox && (
          <Row>
            <Col md={6}>
              <TextArea
                label={"Comments for Send Back"}
                name={"in_form_filling_comments"}
                register={register}
                placeholder="Add Comments here"
                required
                requiredMessage="Comments are required"
                error={errors.in_form_filling_comments?.message}
                onChange={(e) => setSendBackComments(e.target.value)}
              />
            </Col>

            {/* <h1>hello</h1> */}
          </Row>
        )}
        <Row className="mt-2">
          <Col>
            {!showCmntsBox && (
              <div className="text-start">
                <Button
                  label="Send Back for Correction"
                  onClick={() => {
                    setShowCmntsBox(true);
                  }}
                  variant="outline-primary"

                  // type="button"
                />
              </div>
            )}
            {showCmntsBox && (
              <div className="text-start">
                <Button
                  label="Cancel"
                  onClick={() => {
                    setShowCmntsBox(false);
                  }}
                  variant="outline-primary"
                />
                {sendBackSpinner ? (
                  <Spinner animation="border" variant="primary" />
                ) : (
                  <Button
                    label="Send Back"
                    onClick={handleSendBack}
                    // variant="outline-primary"
                  />
                )}
              </div>
            )}
          </Col>
          <Col>
            <div className="text-end">
              {showBtnSpinner ? (
                <Spinner variant="primary" animation="border" />
              ) : (
                <Button
                  label="Submit"
                  onClick={() => UpdateStageAndNavigate()}
                />
              )}
            </div>
          </Col>
        </Row>
      </Container>
      <Row>
        <ValidationErrorModal
          showValidationModal={showValidationModal}
          onHide={() => setShowValidationModal(false)}
          error={validationError}
        />
      </Row>
      <Modal
        show={showModal}
        onHide={() => {
          handleModalClose();
          setSelectedSignatories([]);
        }}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <SectionHeading text="Select Authorised Signatories"></SectionHeading>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <table className="table">
            <thead>
              <tr>
                <th>Action</th>
                <th>Signatory Name</th>
                <th>Signatory Email</th>
                {/* <th className="text-end">Total eSign Sent</th> */}
              </tr>
            </thead>
            <tbody>
              {signatories.map((signatory) => (
                <tr key={signatory.id}>
                  <td>
                    <input
                      type="checkbox"
                      checked={selectedSignatories.includes(signatory.id)}
                      onChange={() => handleSelectChange(signatory.id)}
                    />
                  </td>
                  <td>{signatory.name}</td>
                  <td>{signatory.email}</td>
                  {/* <td className="text-end">
                    {signatory.counter ? signatory.counter : 0}
                  </td> */}
                </tr>
              ))}
            </tbody>
          </table>
        </Modal.Body>
        <Modal.Footer>
          <Button
            label="Close"
            onClick={() => {
              handleModalClose();
              setSelectedSignatories([]);
            }}
            variant="outline-primary"
          ></Button>
          <Button
            label="Confirm Selection"
            onClick={handleConfirmSelection}
          ></Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showPromptModal}
        onHide={() => {
          handlePromptModalClose();
          // setSelectedSignatories([]);
        }}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        // size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <SectionHeading text="Are you sure you want to send for eSign ?"></SectionHeading>
          </Modal.Title>
        </Modal.Header>

        <Modal.Footer>
          <Button
            label="Close"
            onClick={() => {
              handlePromptModalClose();
              // console.log(selectedSignatories);
            }}
            variant="outline-primary"
          ></Button>
          {spinner ? (
            <Spinner animation="border" variant="primary" />
          ) : (
            <Button label="Send" onClick={handleSendConfirm}></Button>
          )}
        </Modal.Footer>
      </Modal>

      <Modal
        show={showPromptModalKp}
        onHide={() => {
          handlePromptModalKpClose();
          // setSelectedSignatories([]);
        }}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        // size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {kpCounter ? (
              <SectionHeading
                text={`Document has already been sent for esign ${kpCounter} time(s). Do you want to send it again for ${kpEmail} `}
              />
            ) : (
              <SectionHeading
                text={`Are you sure you want to eSign with ${kpEmail} `}
              />
            )}
          </Modal.Title>
        </Modal.Header>

        <Modal.Footer>
          <Button
            label="Close"
            onClick={() => {
              handlePromptModalKpClose();
              // console.log(selectedSignatories);
            }}
            variant="outline-primary"
          ></Button>
          {spinnerKp ? (
            <Spinner animation="border" variant="primary" />
          ) : (
            <Button label="Send" onClick={handleSendConfirmKp}></Button>
          )}
        </Modal.Footer>
      </Modal>

      <Modal
        show={show}
        onHide={handleClose}
        keyboard={false}
        dialogClassName="custom-modal"
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Document View</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col className="text-center">
              {showModalSpinner ? (
                <Spinner variant="primary" animation="border" />
              ) : fileType === "pdf" ? (
                <iframe
                  src={imageData + "#toolbar=0"}
                  title="Document viewer"
                  style={{ width: "90%", height: "80vh" }}
                />
              ) : (
                <Image
                  src={imageData}
                  style={{ width: "90%", height: "80vh" }}
                  alt="Document not yet Uploaded"
                />
              )}
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default DocumentSigning;
